module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921135334_T.dec32b19.jpg";